"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StreamingFooter = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactUi = require("@100mslive/react-ui");
var _AudioVideoToggle = require("../AudioVideoToggle");
var _MoreSettings = require("../MoreSettings/MoreSettings");
var _ScreenShare = require("../ScreenShare");
var _PIPComponent = _interopRequireDefault(require("../PIP/PIPComponent"));
var _LeaveRoom = require("../LeaveRoom");
var _MetaActions = _interopRequireDefault(require("../MetaActions"));
var _ChatToggle = require("./ChatToggle");
var _StreamActions = require("../Header/StreamActions");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var StreamingFooter = function StreamingFooter() {
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_reactUi.Footer.Root, {
    css: {
      flexWrap: "nowrap",
      "@md": {
        justifyContent: "center"
      }
    },
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_reactUi.Footer.Left, {
      css: {
        "@md": {
          w: "unset",
          p: "0"
        }
      },
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_AudioVideoToggle.AudioVideoToggle, {})
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_reactUi.Footer.Center, {
      css: {
        "@md": {
          w: "unset"
        }
      },
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_ScreenShare.ScreenshareToggle, {
        css: {
          "@sm": {
            display: "none"
          }
        }
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactUi.Box, {
        css: {
          "@md": {
            display: "none"
          }
        },
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_PIPComponent["default"], {})
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactUi.Box, {
        css: {
          display: "none",
          "@md": {
            display: "flex",
            alignItems: "center",
            mx: "$4"
          }
        },
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_StreamActions.StreamActions, {})
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_MoreSettings.MoreSettings, {}), /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactUi.Box, {
        css: {
          "@md": {
            display: "none"
          }
        },
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_LeaveRoom.LeaveRoom, {})
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactUi.Flex, {
        align: "center",
        css: {
          display: "none",
          "@md": {
            display: "flex"
          }
        },
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_ChatToggle.ChatToggle, {})
      })]
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_reactUi.Footer.Right, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_MetaActions["default"], {}), /*#__PURE__*/(0, _jsxRuntime.jsx)(_ChatToggle.ChatToggle, {})]
    })]
  });
};
exports.StreamingFooter = StreamingFooter;